interface FooterProps {
  hideDetails?: boolean
}

export function Footer({ hideDetails = false }: FooterProps) {
  return (
    <footer className="bg-neutral-50 border-t border-neutral-200">
      <div className="container-max px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex flex-col items-center justify-center space-y-2">
          {/* Logo and Names */}
          <div className="flex items-center space-x-2">
            <div className="script-font text-base text-primary-700">N ♥ E</div>
          </div>
          
          {/* Wedding Date and Message Combined */}
          {!hideDetails && (
            <div className="text-xs text-neutral-500 text-center">
              April 4, 2026 • Oaxaca, Mexico • Thank you for celebrating with us
            </div>
          )}
        </div>
      </div>
    </footer>
  )
}
